import { db, Timestamp } from "@/utils/Firebase";

export const MESSAGE_COLORS = {
    illness: '#d97f3a',
    travel: '#3aa6b9',
    injury: '#df5743',
    competence: '#994eb4',
    wellnessBad: '#df5743',
}

export const sendMessage = async (payload, coachId, studentId) => {
    const messagePayload = {
        read: false,
        timestamp: Timestamp.now(),
        type: 'text',
        ...payload,
    }
    let chatId = await getOrCreateChatId(coachId, studentId)
    await db.collection('privateChats').doc(chatId).collection('messages').add(messagePayload)
    await db.collection('privateChats').doc(chatId).update({ color: messagePayload.color ?? null, lastMessage: messagePayload })
}

// Los dos ordenes: `in` compara el array COMPLETO, asi que buscar solo
// [participantA, participantB] no encuentra los chats guardados al reves y
// termina creando un duplicado.
export const findChat = async (collectionName, type, participantA, participantB) => {
    if (!collectionName || !participantA || !participantB) return null
    const chatRef = await db.collection(collectionName)
        .where('type', '==', type)
        .where('participants', 'in', [[participantA, participantB], [participantB, participantA]])
        .get()
    return chatRef.docs[0] || null
}

export const getOrCreateChatId = async (coachId, studentId) => {
    const chat = await findChat('privateChats', 'coach_student', coachId, studentId)
    if (chat) return chat.id

    const newChat = await db.collection('privateChats').add({
        type: 'coach_student',
        participants: [coachId, studentId]
    })
    return newChat.id
}